import { render, staticRenderFns } from "./HomeTruecaller.vue?vue&type=template&id=27e105b6&"
import script from "./HomeTruecaller.vue?vue&type=script&lang=js&"
export * from "./HomeTruecaller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports